
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SessionService } from './session.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset.password.updated.component.html'
})
export class ResetPasswordUpdatedComponent implements OnInit {

  subscription: Subscription;

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
  ) {

  }

  app: string
  link = '/'
  ngOnInit() {

    this.subscription = this.route.queryParams.subscribe((params) => {

      this.app = params.app;
      SessionService.fixTitle(this.app);
      this.link = `/?app=${this.app}`
    })
  }



}
